import React from 'react';
import { ReviewCard } from './ReviewCard';
import { reviews } from '../data/reviews';
export function ExtendedTestimonials() {
  return <section className="bg-cream px-4 py-20 sm:py-28" data-id="element-55" data-mp="6lkwdowbovdf">
      <div className="mx-auto max-w-6xl" data-id="element-56" data-mp="bjmi6hl4v8sl">
        <div className="mx-auto max-w-3xl text-center" data-id="element-57" data-mp="bil7wfbxyqbx">
          <h2 className="font-serif text-4xl font-semibold leading-tight text-espresso sm:text-5xl" data-id="element-58" data-mp="gbeb2yrrhqlw">
            What Pastry Instructors Are Saying
          </h2>
          <p className="mt-4 text-base leading-7 text-cocoa" data-id="element-59" data-mp="lc22hljwk9gn">
            See how pastry instructors are using Pastry Instructor Ready to save
            time, teach with more structure and make their classes easier to
            prepare.
          </p>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-60" data-mp="z8fdqcxufemo">
          {reviews.map((review, index) => <ReviewCard key={review.role} review={review} index={index} className={index === reviews.length - 1 && reviews.length % 2 === 1 ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-61" data-mp="2w3tsb8ux9ufo" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}